export const CourseLineData = `
  id
  name
  description
  category
  operationMethods
  isActive
  basePrice
`;
